var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);} /* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import { Icon } from "../../UI";
import { actions, Translate, t } from "./..";

import { NeedAuthorization } from "../../Auth";
import { useOnClickOutsideElement } from "../../utils/useOnClickOutsideElementHook";
import { useLocation } from 'react-router-dom';

const locationSearch = (location) => {
  const cleanSearch = location.search.split(/page=\d+|&page=\d+/).join('');
  return cleanSearch === '?' ? '' : cleanSearch;
};

const prepareValues = (
languageMap,
locale,
location) =>
{
  const languages = languageMap.toJS();

  const selectedLanguage =
  languages.find((lang) => lang.key === locale) || languages.find((lang) => lang.default);

  const urlLocation = _objectSpread({}, location);

  const path = urlLocation.pathname.replace(new RegExp(`^/?${locale}/|^/?${locale}$`), '/');

  if (location.search.match(/page=/)) {
    urlLocation.search = locationSearch(location);
  }

  return { languages, selectedLanguage, urlLocation, path };
};

const mapStateToProps = (state) => ({
  languages: state.settings.collection.get('languages'),
  i18nmode: state.inlineEdit.get('inlineEdit'),
  locale: state.locale,
  user: state.user
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ toggleInlineEdit: actions.toggleInlineEdit }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);



const i18NMenuComponent = ({
  languages: languageMap,
  i18nmode,
  user,
  locale,
  toggleInlineEdit
}) => {
  if (!languageMap || languageMap.size < 1 || languageMap.size <= 1 && !user.get('_id')) {
    return /*#__PURE__*/_jsx("div", { className: "no-i18nmenu" });
  }

  const location = useLocation();

  const menuRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { languages, selectedLanguage, path, urlLocation } = prepareValues(
    languageMap,
    locale,
    location
  );

  useEffect(() => {
    if (locale !== (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.key)) {
      window.location.assign(path);
    }
  }, [languages.length]);

  useOnClickOutsideElement(
    menuRef,
    useCallback(() => {
      setDropdownOpen(false);
    }, [])
  );

  return /*#__PURE__*/(
    React.createElement("li", {
      className: languageMap.size === 1 ? 'menuNav-I18NMenu one-language' : 'menuNav-I18NMenu',
      "aria-label": "Languages",
      ref: menuRef },

    i18nmode && /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
    _jsx("div", { className: "menuNav-language" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "singleItem",
      type: "button",
      onClick: toggleInlineEdit,
      "aria-label": t('System', 'Turn off inline translation', null, false) }, void 0, /*#__PURE__*/

    _jsx("div", { className: "live-translate" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "circle", className: i18nmode ? 'live-on' : 'live-off' })
    )
    ), /*#__PURE__*/
    _jsx("span", { className: "singleItem" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Live translate")
    )
    )
    ),


    !i18nmode && /*#__PURE__*/
    _jsx("div", { className: "menuNav-language" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "singleItem dropdown",
      type: "button",
      onClick: () => setDropdownOpen(!dropdownOpen) }, void 0, /*#__PURE__*/

    _jsx("span", {}, void 0, selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.localized_label), "\xA0", /*#__PURE__*/

    _jsx(Icon, { icon: dropdownOpen ? 'caret-up' : 'caret-down' })
    ), /*#__PURE__*/

    _jsx("ul", { className: dropdownOpen ? 'dropdown-menu expanded' : 'dropdown-menu' }, void 0,
    languages.map((language) => {
      const url = `/${language.key}${path}${
      path.match('document') ? '' : urlLocation.search
      }`;

      return /*#__PURE__*/(
        _jsx("li", {

          className: locale === language.key ? 'menuNav-item active' : 'menuNav-item' }, language._id, /*#__PURE__*/

        _jsx("a", { href: url }, void 0, language.localized_label || language.label)
        ));

    }), /*#__PURE__*/

    _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
    _jsx("li", { className: "menuNav-item" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "live-translate",
      type: "button",
      onClick: () => {
        toggleInlineEdit();
        setDropdownOpen(false);
      } }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "circle", className: i18nmode ? 'live-on' : 'live-off' }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Live translate")
    )
    )
    )
    )
    )

    ));

};

const container = connector(i18NMenuComponent);

export { container as i18NMenuComponent };